import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { FiltroDataPage } from "../pages";
import { useAuthDataContext } from "./auth-provider";

import { DashboardLayout } from "./DashboardLayout";

import { EstoquePage } from "../pages/estoque";
import { DashboardPage } from "../pages/dashboard/Dashboard";
import { EncerrantesPage } from "../pages/encerrantes";
import { DebugPage, NoTenantPage, SplashPage } from "../pages/others";
import { CaixasPage } from "../pages/caixa";
import { LoginPage, LogoutPage } from "../pages/login";
import { MyProfilePage } from "../pages/profile/MyProfilePage";
import { StatusBicosPage } from "../pages/statusBicos";
import { EvolucaoPage } from "../pages/dashboard/Evolucao";
import { PrecosPage } from "../pages/precos";
import { FaturasPage } from "../pages/clientApp";
import { InvitesPage } from "../pages/invites";
import { FinanceiroPage } from "../pages/financeiro/FinanceiroPage";

// const PrivateRoute = ({ component, ...options }: any) => {
//   const { user, isStarting } = useAuthDataContext();
//   const finalComponent = user
//     ? user.tenantId
//       ? component
//       : NoTenantScreen
//     : isStarting
//       ? SplashScreen
//       : LoginPage;
//   return <Route {...options} component={finalComponent} />;
// };

export const Router = () => {
  const { user, isStarting } = useAuthDataContext();
  const location = useLocation()

  const routeTitle = routeNameMap[location.pathname];

  return (
    <Switch>
      <Route path="/">
        {user
          ? user.tenantId
            ? user.role === 'Client'
              ? <ClienteApp user={user} />
              : <DashboardApp user={user} currentRouteTitle={routeTitle} />
            : <NoTenantPage />
          : isStarting ? <SplashPage /> : <LoginPage />
        }
      </Route>
      {/* <PrivateRoute path="/" render={DashboarApp} /> */}
    </Switch>
  )
}

const DashboardApp = (props: any) => <DashboardLayout {...props}><DashboardRouter /></DashboardLayout>;

const ClienteApp = (props: any) => <div>
  <Switch>
    <Route exact path="/">
      <Redirect to="/faturas" />
    </Route>
    <Route path="/faturas" component={FaturasPage} />
    <Route path="/perfil" component={MyProfilePage} />
    <Route path="/logout" component={LogoutPage} />
  </Switch>
</div>;

const DashboardRouter = () => (
  <Switch>
    <Route exact path="/">
      <Redirect to="/dashboard" />
    </Route>
    <Route path="/dashboard" component={DashboardPage} />
    <Route path="/evolucao" component={EvolucaoPage} />
    <Route path="/faturamento" component={FinanceiroPage} />
    <Route path="/estoque" component={EstoquePage} />
    <Route path="/caixas" component={CaixasPage} />
    <Route path="/precos" component={PrecosPage} />
    <Route path="/perfil" component={MyProfilePage} />
    <Route path="/encerrantes" component={EncerrantesPage} />
    <Route path="/statusBicos" component={StatusBicosPage} />
    <Route path="/filtroData" component={FiltroDataPage} />
    <Route path="/logout" component={LogoutPage} />
    <Route path="/debug" component={DebugPage} />
    <Route path="/invites" component={InvitesPage} />
  </Switch>
);

const routeNameMap: { [id: string]: string } = {
  '/dashboard': 'Dashboard',
  '/evolucao': 'Evolução',
  '/faturamento': 'Faturamento',
  '/caixas': 'Resumo dos Caixas',
  '/estoque': 'Estoque Atual',
  '/precos': 'Alteração de Preços',
  '/encerrantes': 'Encerrantes Atuais',
  '/perfil': 'Meu Perfil',
  '/statusBicos': 'Status dos Bicos',
  '/filtroData': 'Filtro de Data',
  '/logout': 'Sair?',
}